import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const OfferConfirmation = (props) => {
  return (
    <Box textAlign='center'>
      <Typography  color='initial'  sx={{ mx: 2, my: 4, lineHeight: '2rem', fontSize: '1.375rem' }}>
        Are you sure you want to accept this offer?
      </Typography>
      <Button variant='contained' color='primary' onClick={props.onSubmit}>
        Accept Offer
      </Button>
    </Box>
  );
};

export default OfferConfirmation;
